/**
 * @generated SignedSource<<51e2b0e29dc94be0c3b882ef7f43c776>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoShareToChannelsSettings_stream$data = {
  readonly autoShareSettings: {
    readonly channels: ReadonlyArray<{
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
    }>;
    readonly enabled: boolean;
    readonly id: string;
  };
  readonly " $fragmentType": "AutoShareToChannelsSettings_stream";
};
export type AutoShareToChannelsSettings_stream$key = {
  readonly " $data"?: AutoShareToChannelsSettings_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoShareToChannelsSettings_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoShareToChannelsSettings_stream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StreamAutoShareSettings",
      "kind": "LinkedField",
      "name": "autoShareSettings",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "channels",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPrivate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "14c899a9eb43736c1393a119981918ee";

export default node;
